/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_LedeInputs */

const tr_landing_telegram_lede = /** @type {(inputs: Landing_Telegram_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipariş geldiğinde Telegram'a düşer. Onaylarsınız; bot e-fatura taslağını hazırlar. İmzalarsınız; GİB onayı gelir. Yazdır'a dokunursunuz; mağazadaki yazıcı saniyeler içinde çıktıyı verir.`)
};

const en_landing_telegram_lede = /** @type {(inputs: Landing_Telegram_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When an order comes in, it lands in Telegram. You approve; the bot drafts the e-invoice. You sign; GİB approval comes back. You tap Print; the printer in your store delivers the page within seconds.`)
};

const de_landing_telegram_lede = /** @type {(inputs: Landing_Telegram_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geht eine Bestellung ein, landet sie in Telegram. Sie bestätigen; der Bot erstellt den E-Fatura-Entwurf. Sie signieren; die GİB-Freigabe kommt zurück. Sie tippen auf Drucken; der Drucker im Laden liefert den Ausdruck in Sekunden.`)
};

const ru_landing_telegram_lede = /** @type {(inputs: Landing_Telegram_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда поступает заказ, он сразу приходит в Telegram. Вы подтверждаете; бот готовит черновик e-fatura. Вы подписываете; приходит одобрение GİB. Вы нажимаете «Печать»; принтер в магазине выдает документ за считанные секунды.`)
};

/**
* | output |
* | --- |
* | "When an order comes in, it lands in Telegram. You approve; the bot drafts the e-invoice. You sign; GİB approval comes back. You tap Print; the printer in you..." |
*
* @param {Landing_Telegram_LedeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_lede = /** @type {((inputs?: Landing_Telegram_LedeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_LedeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_lede(inputs)
	if (locale === "de") return de_landing_telegram_lede(inputs)
	if (locale === "ru") return ru_landing_telegram_lede(inputs)
	return tr_landing_telegram_lede(inputs)
});